<template>
  <div>
    <h3 class="componentTitle">喜报图片</h3>
    <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
      <!-- <a-form-item label="喜报图片来源">
        <a-radio-group v-decorator="['imgSource']" @change="e => changeVal(e,'sourceVal')">
          <a-radio :value="0">
            使用实证记录中的照片
          </a-radio>
          <a-radio :value="1">
            从电脑重新上传
          </a-radio>
        </a-radio-group>
        <p class="tips" style="margin: 0 0 10px 0">
          <a-alert
            message="当前市政记录中的照片<2张，建议从电脑重新上传2张"
            banner
            closable
          />
        </p>
      </a-form-item> -->
      <a-form-item label="上传实证照片" v-if="sourceVal === 1">
        <a-space style="display: flex;">
          <div>
            <a-upload
              name="avatar"
              list-type="picture-card"
              class="avatar-uploader"
              :show-upload-list="false"
              :before-upload="e => beforeUpload(e,'Left',0)"
              accept=".jpg,.png"
              @reject="imgReject"
            >
              <img v-if="imageUrlLeft" width="103" :src="imageUrlLeft" alt="avatar" />
              <div v-else>
                <a-icon type="plus" />
                <div class="ant-upload-text">
                  选择左侧图
                </div>
              </div>
            </a-upload>
            <!-- 左侧图 -->
          </div>

          <div>
            <a-upload
              name="avatar"
              list-type="picture-card"
              class="avatar-uploader"
              :show-upload-list="false"
              :before-upload="e => beforeUpload(e,'Right',1)"
              accept=".jpg,.png"
              @reject="imgReject"
            >
              <img v-if="imageUrlRight" width="103" :src="imageUrlRight" alt="avatar" />
              <!-- <div v-if="imageUrlRight" class="uploadImg" :style="{backgroundImage: `url(${imageUrlRight})`}"></div> -->
              <div v-else>
                <a-icon type="plus" />
                <div class="ant-upload-text">
                  选择右侧图
                </div>
              </div>
            </a-upload>
            <!-- 右侧图 -->
          </div>
          
        </a-space>
      </a-form-item>
    </a-form>
    <VueCropper />
  </div>
</template>

<script>
import { mapState,mapMutations } from 'vuex';
import VueCropper from './VueCropper.vue'
export default {
  components: {VueCropper},
  props: {},
  data() {
    return {
      form: this.$form.createForm(this),
      fileListLeft: [],
      fileListRight: [],
      sourceVal: ''
    }
  },
  watch: {},
  computed: {
    ...mapState('news', ['imageUrlLeft','imageUrlRight']),
  },
  created() {},
  mounted() {
    this.sourceVal = 1
    this.form.setFieldsValue({imgSource: 1})
  },
  methods: {
    ...mapMutations('news', ['setState']),
    getBase64(img, callback) {
      const reader = new FileReader();
      reader.addEventListener('load', () => callback(reader.result));
      reader.readAsDataURL(img);
    },
    beforeUpload(file,type,titleKey) {
      this.getBase64(file, imgFile => {
        let imgType = imgFile.split(';')[0]
        if(imgType.indexOf('image') >= 0){
          this.setState({imgFile,addKey: `imageUrl${type}`,titleKey,cropperVisible: true})
          this[`fileList${type}`] = [...this[`fileList${type}`], file];
        }else{
          this.$message.warning('请选择正确的图片类型上传')
          this[`fileList${type}`] = [];
        }
      });
      return true;
    },
    changeVal(e,feild){
      let val = e.target.value
      this[feild] = val
    },
    imgReject(){},
  },
}
</script>
<style lang='scss'></style>
<style lang='scss' scoped></style>